import { useRouter } from "next/navigation";
import { signIn } from "next-auth/react";

export function useAuthFlows() {
  const router = useRouter();

  // Processa autenticação SSO com TA/H
  const processSSO = async (ta: string, h: string) => {
    try {
      console.log("🔄 Iniciando autenticação SSO com TA/H...");

      const response = await fetch(`/api/auth/gsi/sso?ta=${ta}&h=${h}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Falha na autenticação SSO");
      }

      console.log("🎯 Criando sessão NextAuth para SSO...");
      const result = await signIn("GSI", {
        redirect: false,
        userData: JSON.stringify(data.user),
        callbackUrl: "/dashboard",
      });

      if (result?.error) {
        throw new Error("Falha ao criar sessão SSO");
      }

      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);

      console.log("✅ Login SSO realizado com sucesso, redirecionando...");
      router.push("/dashboard");
    } catch (error) {
      console.error("❌ Erro no login SSO:", error);
      throw error;
    }
  };

  // Processa autenticação GovBR via code (SSO)
  const processGovBRSSO = async (code: string) => {
    try {
      console.log("🔄 Iniciando autenticação GovBR SSO...");

      const response = await fetch(`/api/auth/govbr/sso?code=${code}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Falha na autenticação GovBR");
      }

      console.log("🎯 Criando sessão NextAuth para GovBR...");
      const result = await signIn("GSI", {
        redirect: false,
        userData: JSON.stringify(data.user),
        callbackUrl: "/dashboard",
      });

      if (result?.error) {
        throw new Error("Falha ao criar sessão GovBR");
      }

      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);

      console.log("✅ Login GovBR realizado com sucesso, redirecionando...");
      router.push("/dashboard");
    } catch (error) {
      console.error("❌ Erro no login GovBR:", error);
      throw error;
    }
  };

  // Processa autenticação GSI tradicional
  const processGSI = async (
    dominio: string,
    loginAD: string,
    password: string
  ) => {
    try {
      const response = await fetch("/api/auth/gsi/autenticar", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dominio, loginAD, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Falha na autenticação GSI");
      }

      console.log("🎯 Criando sessão NextAuth para GSI...");
      const result = await signIn("GSI", {
        redirect: false,
        userData: JSON.stringify(data.user),
        callbackUrl: "/dashboard",
      });

      if (result?.error) {
        throw new Error("Falha ao criar sessão");
      }

      console.log("✅ Login GSI realizado com sucesso, redirecionando...");
      router.push("/dashboard");
    } catch (error) {
      console.error("❌ Erro no login GSI:", error);
      throw error;
    }
  };

  // Iniciar fluxo GovBR
  const startGovBRFlow = () => {
    const state = Math.random().toString(36).substring(2);
    console.log("🔄 Iniciando fluxo GovBR...");
    window.location.href = `/api/auth/govbr/redirect?state=${encodeURIComponent(
      state
    )}`;
  };

  return {
    processSSO,
    processGovBRSSO,
    processGSI,
    startGovBRFlow,
  };
}
